import { Pipe, PipeTransform } from "@angular/core";
import { format } from "date-fns";

@Pipe({ name: "dateTime", standalone: false })
export class DateTimePipe implements PipeTransform {
  transform(
    value: string | Date,
    formatString: string = "MMM d, yyyy h:mm a",
  ): string {
    if (!value) return "";

    try {
      const date = typeof value === "string" ? new Date(value) : value;
      return format(date, formatString);
    } catch {
      return value?.toString() ?? "Invalid date";
    }
  }
}
